import Tooltip from '@components/shared/Tooltip'
import { PencilSquareIcon } from '@heroicons/react/20/solid'
import store from 'stores/store'
import { useTranslation } from 'next-i18next'

const ShowSlippageSettingsButton = ({ onClick }: { onClick: () => void }) => {
  const { t } = useTranslation('swap')
  const slippage = store((s) => s.swap.slippage)
  return (
    <Tooltip content={t('slippage.edit')}>
      <button
        className={`flex items-center text-xs text-th-fgd-2 focus:outline-none md:hover:text-th-fgd-1 ${
          slippage > 1 ? 'text-th-warning' : ''
        }`}
        onClick={onClick}
      >
        <span>{t('slippage.current', { slippage })}</span>
        <PencilSquareIcon className="ml-1 size-3" />
      </button>
    </Tooltip>
  )
}

export default ShowSlippageSettingsButton
